import { render } from "./Poll.vue?vue&type=template&id=61d0440e"
import script from "./Poll.vue?vue&type=script&lang=js"
export * from "./Poll.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__